import * as React from "react";
import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";
import { COLORS } from "../GLOBAL";

const RightArrow = () => {
  const paths = [
    <path
      d="M94.7197 5.74029C93.9849 5.12764 93.4324 4.10123 92.6976 3.28242C91.9628 2.46361 90.8619 1.85387 89.944 1.24268C89.3932 0.834735 89.7569 -0.198955 90.3076 0.208992C92.1415 1.01907 95.4429 2.43598 95.6335 4.90839C95.8188 5.73156 95.2705 6.14824 94.7197 5.74029Z"
      fill="black"
    />,
    <path
      d="M103.009 21.5488C102.273 20.3177 102.085 18.8761 101.715 17.4359C101.16 15.791 100.606 14.1461 99.6865 12.9164C99.5025 12.5056 99.8676 12.0904 100.234 12.2936C102.255 14.3392 104.463 17.8264 104.656 21.1234C104.475 21.9495 103.377 22.1644 103.009 21.5488Z"
      fill="black"
    />,
    <path
      d="M95.535 34.3898C96.4482 33.3517 97.5446 32.5184 98.2738 31.2756C99.0032 30.0329 99.1828 28.7945 99.3615 27.3499C99.5426 26.5239 100.276 26.9303 100.462 27.5474C100.838 31.0491 99.3818 34.3592 96.6383 35.8241C95.7233 36.0376 94.8044 35.0141 95.535 34.3898Z"
      fill="black"
    />,
    <path
      d="M84.3705 37.5712C84.187 37.3665 84.1858 36.9542 84.3675 36.5404C85.0981 35.71 86.0143 35.9088 86.7473 35.903C88.0293 35.8928 89.1277 35.678 90.225 35.0508C90.9574 34.8388 91.3265 35.8667 90.7781 36.2833C89.6809 36.9105 88.583 37.3316 87.4845 37.5465C86.5704 38.1722 85.1065 38.5961 84.3705 37.5712Z"
      fill="black"
    />,
    <path
      d="M79.4121 33.2812C78.859 32.0486 77.9401 31.0251 77.2044 30.0001C76.2853 28.9766 75.367 28.1593 74.631 26.9282C74.2619 26.1065 74.9929 25.276 75.7265 25.6825C76.8279 26.4984 77.7474 27.7281 78.6672 28.9577C79.4026 29.9827 80.1389 31.2138 80.6917 32.4464C81.061 33.4739 79.9646 34.3076 79.4121 33.2812Z"
      fill="black"
    />,
    <path
      d="M73.5092 19.103C73.505 17.6599 73.6844 16.4215 74.2303 15.1802C74.7769 14.1451 75.8717 12.6933 76.9714 12.6845C77.521 12.6802 78.0729 13.5004 77.708 14.1218C77.1609 14.9508 76.4296 15.5751 75.8819 16.1979C75.3347 17.0269 74.9717 18.0606 74.9741 18.8852C74.9776 20.1221 73.6957 20.3381 73.5092 19.103Z"
      fill="black"
    />,
    <path
      d="M86.6981 18.9982C85.5966 18.1823 84.1312 18.194 83.0333 18.615C82.4844 18.8255 82.1147 17.7977 82.6637 17.5871C84.1273 16.957 85.4084 16.5346 86.875 16.9352C88.1581 17.3374 89.9932 18.3536 90.364 19.7938C90.5487 20.4108 90.001 21.0336 89.4508 20.8318C88.3515 20.6344 87.6155 19.6094 86.6981 18.9982Z"
      fill="black"
    />,
    <path
      d="M93.5168 33.1692C93.1483 32.3474 93.3285 31.3152 92.9589 30.2873C92.5893 29.0533 91.8533 28.0284 91.1179 27.0034C90.5665 26.3893 91.2966 25.5588 91.8479 26.173C93.3175 27.6044 95.8912 30.6764 95.166 33.1561C94.8017 33.9833 93.7026 33.992 93.5168 33.1692Z"
      fill="black"
    />,
    <path
      d="M89.7261 52.578C91.1837 49.8864 92.6417 47.1947 93.549 44.3013C93.9132 43.4737 95.0126 43.6712 94.8327 44.7034C94.1092 48.0077 93.5704 51.7229 90.8287 53.8062C90.281 54.4294 89.3624 53.4059 89.7261 52.578Z"
      fill="black"
    />,
    <path
      d="M78.0254 60.5054C77.2924 60.305 77.2894 59.2743 77.6546 58.859C78.384 57.8224 80.0314 57.397 81.1281 56.5637C82.2248 55.7303 83.3209 54.6908 84.417 53.6513C84.9647 53.0285 85.8836 54.052 85.3361 54.6748C84.2412 56.1267 83.1458 57.3723 82.0503 58.618C80.9542 59.6575 79.4923 60.9057 78.0254 60.5054Z"
      fill="black"
    />,
    <path
      d="M62.827 62.4815C62.2763 62.0736 62.4556 60.8352 63.1889 61.0355C66.1207 61.2184 68.8719 62.4335 71.6193 62.4117C72.1689 62.4073 72.1712 63.232 71.6217 63.2363C68.6917 63.4658 65.3966 64.3162 62.827 62.4815Z"
      fill="black"
    />,
    <path
      d="M56.2231 59.2354C55.1222 58.6257 54.0214 58.0159 53.1025 56.9924C52.0007 55.9704 50.5323 54.9512 50.1618 53.511C49.9768 52.894 50.524 52.065 51.0747 52.473C52.175 52.8766 52.9113 54.1077 53.6461 54.9265C54.5652 55.95 55.6676 57.1782 56.7691 57.9941C57.5039 58.6068 56.9573 59.6419 56.2231 59.2354Z"
      fill="black"
    />,
    <path
      d="M45.5584 45.5073C44.4557 44.2791 43.902 42.8404 43.3477 41.1955C42.976 39.343 42.6025 36.872 43.1472 35.2184C43.5106 34.1847 44.6097 34.176 44.979 35.2039C46.087 38.2875 44.6317 41.8038 46.6551 44.674C47.0232 45.2892 46.1091 45.9153 45.5584 45.5073Z"
      fill="black"
    />,
    <path
      d="M49.3683 32.6948C51.5581 29.7912 56.4896 24.8041 59.9798 28.075C60.5311 28.6891 60.1675 29.7228 59.6185 29.9333C58.1543 30.3573 56.6874 29.9566 55.4066 30.3791C53.5763 31.0121 51.9322 32.4683 50.4703 33.7168C49.5565 34.3426 48.8208 33.318 49.3683 32.6948Z"
      fill="black"
    />,
    <path
      d="M68.2515 37.905C67.3317 36.6753 66.5957 35.4442 65.6762 34.2145C64.5736 32.9863 63.2892 32.1719 62.0043 31.3575C61.4542 31.1557 61.8178 30.122 62.368 30.3238C65.3009 31.1251 69.7035 33.1518 69.5319 37.2763C69.5334 37.8948 68.6196 38.5205 68.2515 37.905Z"
      fill="black"
    />,
    <path
      d="M72.8698 51.2691C72.3131 48.7996 72.6714 46.1167 71.1997 44.0667C70.8325 43.6573 71.3802 43.0345 71.7481 43.4439C73.7684 45.4895 74.5107 48.576 73.9695 51.4665C73.9707 51.8788 73.0548 51.8861 72.8698 51.2691Z"
      fill="black"
    />,
    <path
      d="M75.6706 69.5952C74.1974 66.9268 74.5512 62.5943 74.9083 59.4994C74.9059 58.6747 76.005 58.666 76.1909 59.4892C76.3785 61.137 76.3839 62.9924 76.7553 64.6387C76.9424 66.0803 77.4961 67.5191 77.5003 68.9622C77.321 70.2005 76.039 70.4165 75.6706 69.5952Z"
      fill="black"
    />,
    <path
      d="M68.9402 85.9353C69.485 84.2817 70.3979 83.2436 71.3093 81.7933C72.4048 80.3414 73.133 78.8929 73.8607 77.2375C74.2249 76.4099 75.5087 77.0182 75.3279 77.8443C74.966 79.4965 74.2372 80.7392 73.5089 82.1881C72.5975 83.8446 71.6864 85.5015 70.4086 86.9544C69.8609 87.5769 68.5765 86.9686 68.9402 85.9353Z"
      fill="black"
    />,
    <path
      d="M55.4098 94.7014C54.6762 94.5011 54.6727 93.2642 55.4051 93.0522C57.4176 92.4177 59.2482 91.7847 60.8924 90.3285C61.4407 89.9119 61.992 90.526 61.6272 91.1473C59.9848 93.222 58.1587 95.0916 55.4098 94.7014Z"
      fill="black"
    />,
    <path
      d="M40.0222 94.6172C39.2877 94.0045 39.8337 92.7632 40.567 92.9635C42.9507 93.7689 45.5158 93.9551 47.8977 94.1423C48.6304 94.1365 48.6346 95.5796 47.9019 95.5854C45.3386 96.0184 42.4089 96.4536 40.0222 94.6172Z"
      fill="black"
    />,
    <path
      d="M24.8001 88.3474C24.0656 87.7347 24.9785 86.6967 25.7124 87.1032C28.2805 88.3198 30.6672 90.1562 33.2359 91.579C33.786 91.7808 33.4226 92.8144 32.8725 92.6127C29.9392 91.8113 27.0048 90.5973 24.8001 88.3474Z"
      fill="black"
    />,
    <path
      d="M20.1926 78.6941C18.5386 76.8518 16.1471 73.3664 17.0547 70.4729C17.2355 69.6469 18.3345 69.6381 18.5201 70.4613C18.89 71.6953 18.7104 72.9337 19.0804 74.1677C19.4503 75.4018 20.1866 76.6329 21.1055 77.6564C21.4736 78.2719 20.743 79.1024 20.1926 78.6941Z"
      fill="black"
    />,
    <path
      d="M19.2345 64.2708C19.2292 62.4154 19.5907 60.7632 20.8694 59.5161C21.9655 58.4766 24.3421 56.8085 25.8105 57.8276C26.5444 58.2341 26.3642 59.2663 25.8164 59.8892C25.2681 60.3058 24.9017 60.3087 24.3522 60.3131C23.8027 60.3175 23.0705 60.5294 22.5222 60.9461C21.4249 61.5733 20.1463 62.8204 19.9672 64.265C19.9693 64.8831 19.2363 64.8889 19.2345 64.2708Z"
      fill="black"
    />,
    <path
      d="M38.1143 68.2441C36.8291 67.2235 35.9084 65.5815 34.8063 64.5591C33.5205 63.3327 32.0527 62.5197 30.5849 61.7067C29.851 61.3003 30.3969 60.059 31.1302 60.2593C34.0635 61.0606 38.4669 63.4996 39.393 66.997C39.5785 67.8201 38.665 68.6517 38.1143 68.2441Z"
      fill="black"
    />,
    <path
      d="M46.4055 84.8772C45.668 83.2338 45.4801 81.586 44.9252 79.735C44.3685 77.2652 43.2634 75.2123 41.7926 73.3686C41.0575 72.5501 42.153 71.3041 42.8881 72.1229C45.6442 74.9873 48.0404 80.1222 48.0529 84.4515C48.055 85.2761 46.7743 85.699 46.4055 84.8772Z"
      fill="black"
    />,
    <path
      d="M34.1815 101.879C35.0944 100.841 36.3761 100.625 37.474 100.204C38.9376 99.5736 40.5838 98.7359 41.8631 97.6946C42.5934 96.8645 43.6961 98.0927 42.9657 98.9231C41.8703 100.169 40.591 101.209 39.3111 102.045C38.0313 102.88 36.3856 103.923 34.9196 103.729C34.1863 103.529 33.6338 102.502 34.1815 101.879Z"
      fill="black"
    />,
    <path
      d="M21.0081 107.344C23.0153 104.648 27.226 103.79 30.1575 103.973C31.0734 103.966 31.0775 105.409 30.1622 105.622C28.8806 105.838 27.4163 106.263 26.1353 106.685C24.6716 107.315 23.393 108.562 21.9287 108.986C21.0128 108.994 20.46 107.967 21.0081 107.344Z"
      fill="black"
    />,
    <path
      d="M11.3234 115.668C11.1366 114.432 12.0495 113.394 12.5967 112.565C13.3264 111.528 14.4237 110.901 15.3384 110.481C16.2531 110.062 16.99 111.499 16.0753 111.919C15.3444 112.543 14.6128 112.961 13.8825 113.791C13.3354 114.62 13.1558 115.859 12.2411 116.279C12.0585 116.486 11.5084 116.285 11.3234 115.668Z"
      fill="black"
    />,
    <path
      d="M7.1436 127.246C5.31062 126.848 3.29386 126.245 1.45969 125.435C0.909558 125.234 0.358232 124.62 0.356441 124.001C0.527685 119.876 1.61601 116.157 3.62083 112.636C4.34997 111.394 6.00156 112.412 5.4562 113.859C3.99913 116.756 3.27477 119.649 3.28372 122.741C4.56716 123.143 5.85061 123.545 7.13405 123.947C8.60068 124.348 10.0655 124.13 11.1676 125.152C11.9021 125.765 11.5387 126.798 10.9904 127.215C9.89426 128.255 8.24357 127.649 7.1436 127.246Z"
      fill="black"
    />,
  ];
  const controls = useAnimation();

  useEffect(() => {
    controls.start("animate");
  }, [controls]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="105"
      height="128"
      viewBox="0 0 105 128"
      fill="none"
    >
      {paths.map((path, index) => (
        <motion.path
          key={index}
          d={path.props.d}
          fill="black"
          initial={{ pathLength: 0, fill: "rgba(0, 0, 0, 0)" }}
          animate={{ pathLength: 1, fill: "#000000" }}
          transition={{
            pathLength: {
              delay: index * 0.09,
              type: "tween",
              duration: 0.3,
              bounce: 0,
            },
            fill: { delay: index * 0.09, type: "tween", duration: 0.1 },
          }}
        />
      ))}
    </svg>
  );
};

export default RightArrow;
